<reporter-modal [show]="show"
                [displayCloseBtn]="true"
                [noFooter]="true"
                [modalTitle]="(contactType === 'MEDICAL' ? 'Medical' : 'Employee') + ' Contact Lookup'"
                modalClasses="modal-lg"
                (onClose)="close.emit(true)">
  <div role="modal-body">
    <div class="content">
      <reporter-notifications [clearOnNew]="true"></reporter-notifications>
      <div class="contacts-search"
           [ngClass]="{'overflow-hidden': !contactsSearchOpen}">
        <div class="contact-search-control"
             (click)="contactsSearchOpen = !contactsSearchOpen">
          <div>
            @if (contactsSearchOpen) {
              <reporter-icon
                icon="Expanded"></reporter-icon>
            }
            @if (!contactsSearchOpen) {
              <reporter-icon
                icon="Collapsed"></reporter-icon>
            }
            <span class="pl-3">Contacts Search Criteria</span>
          </div>
        </div>
        <form role="form"
              #form="ngForm"
              class="px-2">
          @if (contactsSearchOpen) {
            <div class="search-form row mx-0 py-2"
            >
              <div class="form-group col-12 col-md-6">
                <label for="firstName">First Name</label>
                <input type="text"
                       id="firstName"
                       name="firstName"
                       placeholder="First Name"
                       [(ngModel)]="searchModel['firstName']"
                       class="form-control"/>
              </div>
              <div class="form-group col-12 col-md-6">
                <label for="lastName">Last Name</label>
                <input type="text"
                       id="lastName"
                       name="lastName"
                       placeholder="Last Name"
                       [(ngModel)]="searchModel['lastName']"
                       class="form-control"/>
              </div>
              @if (contactType === 'EMPLOYEE') {
                <div class="form-group col-12 col-md-6">
                  <label for="email">Email</label>
                  <input type="email"
                         id="email"
                         name="email"
                         placeholder="Email address"
                         [(ngModel)]="searchModel['email']"
                         class="form-control"/>
                </div>
              }
              @if (contactType === 'EMPLOYEE') {
                <div class="form-group col-12 col-md-6">
                  <label for="employeeNumber">Employee Number</label>
                  <input type="text"
                         id="employeeNumber"
                         name="employeeNumber"
                         placeholder="Employee Number"
                         [(ngModel)]="searchModel['employeeNumber']"
                         class="form-control"/>
                </div>
              }
              @if (contactType === 'EMPLOYEE') {
                <div class="form-group col-12 col-md-6">
                  <label for="ssn">SSN</label>
                  <input type="text"
                         id="ssn"
                         name="ssn"
                         placeholder="SSN"
                         [(ngModel)]="searchModel['ssn']"
                         class="form-control"/>
                </div>
              }
              <div class="form-group col-12 col-md-6">
                <label for="companyName">Company Name</label>
                <input type="text"
                       id="companyName"
                       name="companyName"
                       placeholder="Company Name"
                       [(ngModel)]="searchModel['companyName']"
                       class="form-control"/>
              </div>
              <div class="form-group col-12 col-md-6">
                <label for="city">City</label>
                <input type="text"
                       id="city"
                       name="city"
                       placeholder="City"
                       [(ngModel)]="searchModel['city']"
                       class="form-control"/>
              </div>
              <div class="form-group col-12 col-md-6">
                <label for="jurisdiction">State</label>
                <select
                  class="form-control"
                  id="jurisdiction"
                  name="jurisdiction"
                  [class.placeholder]="!searchModel['state']"
                  [(ngModel)]="searchModel['state']">
                  <option [ngValue]="undefined">State</option>
                  @for (jurisdiction of jurisdictions; track jurisdiction; let index = $index) {
                    <option
                      [ngValue]="jurisdiction.key">{{ jurisdiction.displayValue }}
                    </option>
                  }
                </select>
              </div>
              <div class="form-group col-12 col-md-6">
                <label for="postalCode">Postal Code</label>
                <input type="text"
                       class="form-control"
                       id="postalCode"
                       name="postalCode"
                       placeholder="Postal Code"
                       [(ngModel)]="searchModel['zip']">
              </div>
              <div class="d-flex col-12 justify-content-end align-items-center py-2 py-lg-0 mt-5">
                <button type="button"
                        class="btn btn-action"
                        data-test-id="search-form-clear"
                        (click)="resetForm()">CLEAR
                </button>
                <button type="submit"
                        class="btn btn-action ml-3"
                        (click)="search()">SEARCH
                </button>
              </div>
            </div>
          }
        </form>
      </div>
      @if (contacts) {
        <div
          class="results-count">{{ totalRecords }} record{{ totalRecords !== 1 ? 's' : '' }} found
        </div>
      }

      @if (contacts?.length) {
        <div class="search-results"
             infiniteScroll
             [scrollWindow]="false"
             [infiniteScrollDistance]="1"
             [infiniteScrollThrottle]="50"
             [infiniteScrollDisabled]="pageNumber >= totalPages"
             (scrolled)="loadNextPage()">
          <div class="results-list">
            @for (contact of contacts; track contact; let index = $index) {
              <div
                class="list-group-item"
                [class.zebra]="index % 2 == 1">
                <div class="reporting-location cursor-pointer col"
                     (click)="getDetails(contact)"
                     (mouseenter)="mouseOver(contact)"
                     (mouseleave)="unsetTimeOut(contact)">
                  <div class="d-flex align-middle justify-content-between">
                    <div>
                      <div>Name: {{ contact.firstName }} {{ contact.lastName }} {{ contact.companyName }}</div>
                      <div class="small text-muted">
                        Location: {{ contact.locationName }}
                      </div>
                    </div>
                    @if (contact.id === details?.id) {
                      <button
                        class="btn btn-action py-0"
                        (click)="select(contact)">
                        Select
                      </button>
                    }
                  </div>
                  @if (contact.id === details?.id) {
                    <reporter-contact-details
                      [contact]="details"></reporter-contact-details>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }

      <div class="results">

      </div>
    </div>
  </div>
</reporter-modal>
